<div class="product-card border rounded-lg" [ngClass]="{ 'disabled-card': !part.quantityAvailable }">
  <part-card-header [idSuffix]="idSuffix" (partChange)="changeFavorite($event)" [part]="part" [partType]="partType"></part-card-header>
  <div>
    <part-card-item [idSuffix]="idSuffix" [(part)]="part" [allowPriceAdjust]="allowPriceAdjust"></part-card-item>
    <part-card-description [idSuffix]="idSuffix" [part]="part"></part-card-description>
    <part-card-add-to-cart [idSuffix]="idSuffix" [part]="part" [partType]="partType" (addedToCart)="addedToCart.emit($event)" [sourcePart]="sourcePart"></part-card-add-to-cart>
  </div>
  <part-card-footer [idSuffix]="idSuffix" [part]="part" (addedToCart)="addedToCart.emit($event)"></part-card-footer>
</div>
